// API Configuration
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

export { API_URL };
export default API_URL;
